
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/property-management",
      function () {
        return require("private-next-pages/dashboard/property-management.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/property-management"])
      });
    }
  